import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";
import { Platform, ViewStyle } from "react-native";
import ResponsiveStylesheet from "react-native-media-query";

export const { styles, ids } = ResponsiveStylesheet.create({
  nextWrap: createResponsiveStyles({
    base: {
      justifyContent: "space-between",
      marginTop: theme.spacing.medium,
      alignItems: "center",
    },
    small: {
      flexDirection: "row",
    },
    medium: {
      marginTop: "auto",
      marginLeft: "auto",
    },
  }),
  searchError: {
    marginTop: theme.spacing.xlarge,
    marginHorizontal: "auto",
    backgroundColor: theme.colors.negative.base,
  },
  description: createResponsiveStyles({
    base: {
      marginRight: theme.spacing.small,
      marginBottom: theme.spacing.small,
    },
    small: {
      marginBottom: 0,
    },
  }),
  nextButton: createResponsiveStyles({
    base: {
      width: 140,
      alignSelf: "center",
      marginBottom: theme.spacing.xsmall,
    },
    medium: {
      alignSelf: "flex-end",
    },
  }),
});
